export const fetchImage = async (image) => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // In the event that an image takes longer than 3 seconds to load,
    // resolve the promise to allow rendering to continue.
    const handle = setTimeout(() => {
      resolve({ image, errorMsg: `Timeout elapsed when loading image [${img.src}]` });
      // @ts-ignore
      img.onLoad = undefined;
      // @ts-ignore
      img.onerror = undefined;
      img.src = '';
    }, 3000);

    img.onload = () => {
      clearTimeout(handle);
      resolve({ image, img });
    };

    img.onerror = (event) => {
      clearTimeout(handle);
      resolve({ image, errorMsg: `Unable to load image [${image.src}]` });
      return false;
    };

    img.width = image.width;
    img.height = image.height;
    img.src = image.src;
  });
};

export const handleFetchImage = (canvasContext, { img, image, errorMsg }) => {
  if (!canvasContext) return;

  if (errorMsg) {
    console.warn(errorMsg);
  }

  if (img && image) canvasContext.drawImage(img, image.x, image.y, image.width, image.height);
};
